export const validate = (text: string) => text.trim() !== '';